// Retry automático pra chamadas de LEITURA (GET, ou POST que só consulta,
// nunca dispara uma ação) contra falhas transitórias: erro de rede do fetch,
// ou os status que o backend usa pra sinalizar indisponibilidade momentânea —
// 502/504 (gateway) e 503 (handler global de erro de banco: qualquer query
// que estoure o timeout sob concorrência vira 503 + Retry-After, em vez de
// 500 cru). Não inclui 500: esse é erro de aplicação, não vale reter.
//
// NÃO usar em chamadas que disparam uma ação (ex.: POST /interno/rodar-relatorio
// em internoApi.js) — repetir automaticamente arriscaria duplicar o efeito.
// O polling de status em internoApi.js/RodarRelatorio.jsx também fica de fora
// de propósito: já tem sua própria lógica de retry/backoff com limite e
// feedback específico pro usuário (botão "Verificar novamente"), que não deve
// se somar a um segundo nível de retry aqui.
const STATUS_RETRIAVEIS = new Set([502, 503, 504]);
const MAX_RETRIES = 2; // até 3 tentativas no total (1 original + 2 retries)
const DELAY_BASE_MS = 900;
const DELAY_MAX_MS = 8000;

function espera(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

function delayBackoff(tentativa) {
  return Math.min(DELAY_BASE_MS * Math.pow(2, tentativa), DELAY_MAX_MS);
}

function delayParaRetry(res, tentativa) {
  const retryAfter = Number(res.headers.get('Retry-After'));
  if (Number.isFinite(retryAfter) && retryAfter >= 0) return Math.min(retryAfter * 1000, DELAY_MAX_MS);
  return delayBackoff(tentativa);
}

// Mesma assinatura do fetch nativo — troca direta em qualquer chamada de
// leitura (`options.body`, se houver, precisa ser string já serializada, não
// um stream, pra poder ser reenviada em cada tentativa — é o caso de todo
// JSON.stringify(...) já usado nos serviços deste projeto).
export async function fetchComRetry(url, options) {
  for (let tentativa = 0; ; tentativa++) {
    const ultimaTentativa = tentativa >= MAX_RETRIES;
    let res;
    try {
      res = await fetch(url, options);
    } catch (e) {
      if (ultimaTentativa) throw e;
      await espera(delayBackoff(tentativa));
      continue;
    }
    if (res.ok || !STATUS_RETRIAVEIS.has(res.status) || ultimaTentativa) return res;
    await espera(delayParaRetry(res, tentativa));
  }
}
